import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleFeature from '../../components/Feature';

import featureImg1 from '../../assets/img/feature/fea-1.png';
import featureImg2 from '../../assets/img/feature/fea-2.png';
import featureImg3 from '../../assets/img/feature/fea-3.png';

const Feature = () => {
  return (
    <div className="feature__area feature__mlr pt-100 pb-70">
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div
            className="col-xl-6 wow animate__fadeInUp"
            data-wow-duration="1.1s"
          >
            <SectionTitle
              subTitle="Our Commitment to Excellence"  
              Title="Why Choose PRD Infotech?" 
              Description="Our advanced solutions, customer-centric approach, and innovation-driven mindset set us apart. Discover what makes us different."
            />
          </div>
        </div>
        <div className="row">
          {/* Feature 1: Innovative Solutions */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
          >
            <SingleFeature
              itemClass="feature__item feature__color-1 text-center"
              Image={featureImg1}
              Title="Innovative Solutions"
              Description="We leverage cutting-edge technology to deliver modern, scalable, and future-ready solutions that empower businesses to grow and succeed."
              btnText="Learn More"
              btnURL="/about-us"
            />
          </div>

          {/* Feature 2: Customization & Flexibility */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".7s"
          >
            <SingleFeature
              itemClass="feature__item feature__color-2 text-center"
              Image={featureImg2}
              Title="Tailored to Your Needs"
              Description="Every business is unique, and so are our solutions. We customize our services to fit your specific challenges and operational goals."
              btnText="See How"
              btnURL="/services"
            />
          </div>

          {/* Feature 3: Reliable & Scalable Systems */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration="1.1s"
            data-wow-delay=".9s"
          >
            <SingleFeature
              itemClass="feature__item feature__color-3 text-center"
              Image={featureImg3}
              Title="Reliability & Scalability"
              Description="Our technology ensures high performance, security, and the ability to scale as your business grows, keeping you ahead of the competition."
              btnText="Explore More"
              btnURL="/services"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
